// src/components/league/LeagueGrid.jsx

import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import LeagueCard from './LeagueCard';

const LeagueGrid = ({ 
  leagues = [], 
  loading = false, 
  error = null,
  orgId,
  isPublic = false,
  onLeagueDelete,
  onLeagueNavigate,
  emptyMessage = "No leagues found.",
  loadingSkeletonCount = 3
}) => {
  if (error) {
    return (
      <Grid size={12}>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="error">{error}</Typography>
        </Box>
      </Grid>
    );
  }

  if (loading) {
    // Loading skeleton - show placeholder cards
    return (
      <>
        {Array.from({ length: loadingSkeletonCount }, (_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={`loading-${index}`}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 140
                }}>
                  <CircularProgress size={24} sx={{ mb: 2 }} />
                  <Typography variant="body2" color="text.secondary">
                    Loading...
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </>
    );
  }

  if (leagues.length === 0) {
    return (
      <Grid size={12}>
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary">{emptyMessage}</Typography>
        </Box>
      </Grid>
    );
  }

  return (
    <>
      {leagues.map(league => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={league.id || league.leagueId}>
          <LeagueCard 
            league={league}
            orgId={orgId}
            isPublic={isPublic}
            onDelete={onLeagueDelete}
            onNavigate={onLeagueNavigate}
          />
        </Grid>
      ))}
    </>
  );
};

export default LeagueGrid;